import { cn } from '@repo/utils/cn';
import { type ReactNode } from 'react';

type HeaderTitleProps = {
  children: ReactNode;
  className?: string;
};

export const HeaderTitle = ({ children, className }: HeaderTitleProps) => (
  <span
    className={cn(
      'font-black vt-font-highlight-font-family vt-text-size-medium vt-headings-text sm:vt-text-size-big',
      className
    )}
  >
    {children}
  </span>
);
